import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=6ccf4ef5&scoped=true"
import script from "./vipList.vue?vue&type=script&lang=js"
export * from "./vipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf4ef5",
  null
  
)

export default component.exports